import React, { PureComponent } from 'react';
import { Platform, PixelRatio, BackHandler, Dimensions } from 'react-native';
import { verUtil, commonUtil, dateUtil, performanceUtil, logEvent, QavEvent } from '@qnpm/q-design-utils';
import { QPopupLayer } from '@qnpm/q-popup-layer';
import { QGestureFloat, RNGestureFloat } from '@qnpm/q-gesture-float';
import Theme from '@qnpm/q-theme';
import ShellComponentHOC from '../ShellComponentHOC';
import NaviBar from './Navibar';
import { CALENDAR_TYPE } from '../Calendar';
import CalendarBottomModule from '../BottomModule';
import { computedFixedIndexes, processDecelerationRate, computedSelectedSectionIndexes, computedInitScrollPosition, updateUserSelectedDate, getDeviceProps, validAndAdjustProps } from '../utils/handle';
import Style from '../Calendar/style';
import { generatorRangeCalendar, generatorWeekHeader } from '../utils/dateUtil';
import HolidayUtil from '../utils/holidayUtil';
const isIOS = Platform.OS === 'ios';
const { calendar: calendarLayout } = Theme.layout;
const importsCalendar = {
    get qSection() {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        return require('../Calendar').QSectionCalendar;
    },
    get section() {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        return require('../Calendar').SectionCalendar;
    },
    get native() {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        return require('../Calendar').NativeSectionContent;
    }
};
export default class FloatCalendar extends PureComponent {
    constructor(props) {
        super(props);
        this.qGestureFloat = null;
        this.calendarData = [];
        // 选择日期的真正滚动距离
        this.pageOffset = 0;
        // 临时记录的选择的日期的滚动距离 - 页面关闭时将其赋值非pageOffset
        this.tempPageOffset = 0;
        // 标记 - 用户是否滚动过
        this.hasScrolled = false;
        // 标记 - 用户使用手动选择过
        this.userSelected = false;
        this.weekHeaderData = [];
        /**
         * 关闭手势浮层
         */
        this.closeGestureFloat = () => {
            if (this.useNativeGestureFloat) {
                this.setState({ pageNumber: -1 });
            }
            else if (this.useRNGestureFloat) {
                this.qGestureFloat &&
                    this.qGestureFloat.hideFloat();
            }
            else {
                this.onClose(false);
            }
        };
        this.onScroll = () => {
            if (!this.hasScrolled) {
                this.hasScrolled = true;
            }
        };
        /**
         * 日历layout完成后，滚动到选中位置
         */
        this.onCalendarLayout = (_, offset) => {
            // 页面加载完成后，滚动到选中位置
            !this.hasScrolled && offset && this.onSelectScroll(offset);
        };
        /**
         * 选中后滚动到对应位置
         */
        this.onSelectScroll = (offset) => {
            var _a;
            const calendarHeight = (this.calendarRef && ((_a = this.calendarRef) === null || _a === void 0 ? void 0 : _a.calendarHeight)) ||
                Number.MAX_SAFE_INTEGER;
            // 滚动距离大于等于日历高度时，直接滚动到底部
            if (offset >= calendarHeight) {
                this.qGestureFloat && this.qGestureFloat.topPageScrollToEnd(true);
                return;
            }
            // 选中时，直接滚动到选中位置；这里由selectScroll属性控制
            this.qGestureFloat && this.qGestureFloat.topPageScrollTo(offset, true);
        };
        /**
         * 所有日历渲染完成 - 设置阻尼系数
         */
        this.onRenderFinished = () => {
            const decelerationRate = processDecelerationRate('normal');
            this.setState({ decelerationRate, scrollRate: 1 });
        };
        /**
         * 选中回调
         * @param data
         */
        this.onSelect = (data) => {
            const { onSelect, mode } = this.props;
            const { selectedIndex } = data;
            // 更新选中数据
            this.updateSelectedDate(data);
            // 标记
            this.userSelected = true;
            // 执行回调 - 单选时延迟回调
            if (mode === CALENDAR_TYPE.SINGLE) {
                setTimeout(() => {
                    onSelect && onSelect(data);
                }, 100);
            }
            else {
                onSelect && onSelect(data);
            }
            // 安卓端，选择第一个时，计算位置；为下次点开滚动做准备
            !isIOS &&
                selectedIndex === 0 &&
                setTimeout(() => this.fixInitScrollOnAdr([data.value], false));
        };
        /**
         * 页面状态变化 - 设置浮层状态
         */
        this.onStateChange = (_, state) => {
            const { onFloatShow } = this.props;
            if (state !== 'hide') {
                const floatDidMount = state === 'half';
                this.setState({ floatDidMount }, () => {
                    floatDidMount && this.onFloatRendered(floatDidMount);
                });
                // 浮层弹起回调
                floatDidMount && onFloatShow && onFloatShow();
            }
        };
        /**
         * 渲染完成埋点
         * @param visible
         * @private
         */
        this.onFloatRendered = (visible) => {
            if (visible) {
                const { accessibilityPreName, gestureType } = this.props;
                const startDate = dateUtil.toDate(this.beginTime);
                const duration = Date.now() - startDate.getTime();
                logEvent(new QavEvent({
                    page: accessibilityPreName,
                    model: 'float_calendar',
                    action: 'calendar_first_rendered_time',
                    attributes: {
                        duration,
                        useGesture: this.useNativeGestureFloat ||
                            this.useRNGestureFloat,
                        gestureType,
                        operTime: Date.now()
                    }
                }));
            }
        };
        /**
         * 是否在滚动
         * @param _
         * @param isTouchMoving
         */
        this.onTouchMoveChange = (_, isTouchMoving) => {
            this.setTouchMovingState(isTouchMoving);
        };
        /**
         * 修复固定头部点击穿透问题
         * @param _
         * @param isTouchMoving
         */
        this.onFixItemTouchChange = (_, isTouchMoving) => {
            this.setTouchMovingState(isTouchMoving);
        };
        /**
         * 调用外部关闭回调函数
         * @param val
         */
        this.onClose = (val = false) => {
            const { onClose } = this.props;
            onClose && onClose(val);
        };
        /**
         * 浮层关闭回调
         * @param closingPageNumber
         */
        this.onCloseHandler = (closingPageNumber) => {
            this.resetFloatState(closingPageNumber, -1);
        };
        /**
         * 关闭动画执行完成回调
         * @param closedPageNumber
         */
        this.onCloseAnimateFinishHandler = (closedPageNumber) => {
            this.resetFloatState(closedPageNumber, -2, this.onClose);
        };
        /**
         * 默认选中日期的回调
         * @param data
         */
        this.onInitCallback = (data) => {
            const { onInitCallback } = this.props;
            const nextData = Array.isArray(data) ? data : [data];
            commonUtil.isFunction(onInitCallback) && onInitCallback(data);
            // 使用setTimeout将异步setState变为同步更新，防止底部渲染时首次拿不到数据
            setTimeout(() => {
                this.setState({ userSelectedDate: nextData });
            });
        };
        // dataSource改变，渲染完成回调
        this.onDataSourceRendered = (data) => {
            const { onDataSourceRendered } = this.props;
            let nextData = [];
            commonUtil.isFunction(onDataSourceRendered) &&
                onDataSourceRendered(data);
            // 用户如果没有手动选择过，则每次dataSource更新后都更新底部展示数据
            if (!this.userSelected) {
                if (commonUtil.isValidObject(data)) {
                    nextData = [data];
                    // @ts-ignore
                }
                else if (commonUtil.isValidArray(data)) {
                    nextData = data;
                }
            }
            // 只有不为空时才更新
            commonUtil.isValidArray(nextData) &&
                this.setState({ userSelectedDate: nextData });
        };
        /**
         * 这里每次选中都会调用，所以不是数组
         * @param data
         */
        this.updateSelectedDate = (data) => {
            const { mode } = this.props;
            const { userSelectedDate } = this.state;
            const { selectedIndex = 0 } = data;
            let nextState = userSelectedDate
                ? [...userSelectedDate]
                : [];
            // selectedIndex为0时，表示选择了第一个日期，此时需要重置用户选择的日期
            if (selectedIndex === 0) {
                nextState = [data];
            }
            else {
                // selectIndex不为0时，表示继续选择
                nextState[selectedIndex] = data;
            }
            this.setState({ userSelectedDate: nextState });
            // 如果是单选日期，则在选择日期后记录停留时长
            mode === CALENDAR_TYPE.SINGLE && this.printStayLog(nextState);
        };
        /**
         * 点击固定头部时，打开连接
         * @param _
         * @param index
         */
        this.onFixItemTouch = (_, index) => {
            var _a;
            // ios直接返回
            if (isIOS) {
                return;
            }
            const url = (_a = this.calendarRef) === null || _a === void 0 ? void 0 : _a.getMonthUrlByIndex(index);
            url && commonUtil.openURL(url, { type: 'navibar-none' });
        };
        /**
         * 停留时长埋点
         * @private
         */
        this.printStayLog = (data) => {
            try {
                const { selectedDate, accessibilityPreName } = this.props;
                const userSelectedData = data || this.state.userSelectedDate;
                // 这里的日历可能是Date类型，转成字符串类型
                const defaultDateStr = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.map((val) => dateUtil.dateFormat(val)).join(',');
                const newDateStr = userSelectedData === null || userSelectedData === void 0 ? void 0 : userSelectedData.map((item) => item.value).join(',');
                // 只有日期发生变化才记录
                if (defaultDateStr !== newDateStr) {
                    const startDate = dateUtil.toDate(this.beginTime);
                    logEvent(new QavEvent({
                        page: accessibilityPreName,
                        model: 'float_calendar',
                        action: 'stay_time',
                        attributes: {
                            duration: Date.now() - startDate.getTime(),
                            operTime: Date.now(),
                            prevDate: defaultDateStr,
                            curDate: newDateStr
                        }
                    }));
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.warn('日历停留时长埋点出错', e);
            }
        };
        const { selectedPayload, minDate, maxDate, locale = 1, startWeek = 0, stickyHeader } = props;
        this.initDecelerationRate = processDecelerationRate('fast');
        // 计算节假日信息，实例化时传入节假日信息；默认使用了mock数据
        this.HolidayUtilHandler = new HolidayUtil();
        this.beginTime = props.beginTime || new Date();
        this.state = {
            pageNumber: props.visible ? 0 : -2,
            floatDidMount: false,
            isTouchMoving: false,
            decelerationRate: this.initDecelerationRate,
            scrollRate: 0.5,
            prevSelectedPayload: props.selectedPayload,
            dataSource: this.HolidayUtilHandler.mergeHolidayData(props.dataSource),
            fixedIndexes: stickyHeader
                ? computedFixedIndexes(commonUtil.isValidArray(selectedPayload), minDate, maxDate)
                : [],
            refreshWidth: Dimensions.get('window').width
        };
        this.supportQGestureFloat = verUtil.overVer.overV3;
        // 日历不支持缩放
        this.computedStyle = new Style(false);
        this.weekHeaderData = generatorWeekHeader(locale, startWeek);
        this.calendarRef = null;
        this.deviceProps = getDeviceProps(props.initialNumToRender, props.useGesture, props.gestureType);
        // 安卓上需要生成日历结构以计算初始滚动位置
        !isIOS && this.createCalendarData();
        // 打印提示信息
        this.printNotifyMessage();
        this.onChange = this.onChange.bind(this);
    }
    // 提示变化时，重新计算固定元素下标
    static getDerivedStateFromProps(nextProps, prevState) {
        const { prevSelectedPayload } = prevState || {};
        const { selectedPayload, minDate, maxDate, stickyHeader } = nextProps;
        if (stickyHeader &&
            !performanceUtil.fastDeepEqual(prevSelectedPayload, selectedPayload)) {
            const fixedIndexes = computedFixedIndexes(commonUtil.isValidArray(selectedPayload), minDate, maxDate);
            return { prevSelectedPayload: selectedPayload, fixedIndexes };
        }
        return null;
    }
    onChange(dimensions) {
        const { width } = dimensions.window;
        this.setState({ refreshWidth: width });
    }
    componentDidMount() {
        // 如果是native浮层时，添加物理返回键监听
        if (!isIOS && this.useNativeGestureFloat) {
            this.listenerHandler = BackHandler.addEventListener('hardwareBackPress', () => {
                const { pageNumber } = this.state;
                // 只有日历展示时，才需要阻止事件冒泡
                if (pageNumber === 0) {
                    // 调用关闭方法
                    this.onClose(false);
                    return true;
                }
                return false;
            });
        }
        // 适配折叠屏
        Dimensions.addEventListener('change', this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        const { visible: preVisible } = prevProps;
        const { pageNumber } = prevState;
        const { visible } = this.props;
        if (visible !== preVisible) {
            this.update(visible, pageNumber);
            // 设置左滑收拾（展示时禁止，否则设置为可用）
            this.toggleSwipeControl(!visible);
        }
        this.updateDataSource(prevProps);
    }
    componentWillUnmount() {
        this.listenerHandler && this.listenerHandler.remove();
        this.hasScrolled = false;
        Dimensions.removeEventListener('change', this.onChange);
    }
    render() {
        const { headerData, contentData, footerData } = this.getRenderData();
        // 支持走native浮层且使用手势时，使用native
        if (this.useNativeGestureFloat) {
            return this.renderHighVersion(headerData, contentData, footerData);
        }
        else {
            return this.renderLowVersion(headerData, contentData, footerData);
        }
    }
    /**
     * 是否使用native手势浮层
     * @private
     */
    get useNativeGestureFloat() {
        const { useGesture: pUseGesture, gestureType: pGestureType } = this.props;
        const { useGesture = pUseGesture, gestureType = pGestureType } = this.deviceProps;
        // 支持native浮层&使用手势&指明使用native手势浮层
        return this.supportQGestureFloat && useGesture && gestureType === 1;
    }
    /**
     * 是否RN手势浮层
     * @private
     */
    get useRNGestureFloat() {
        const { useGesture: pUseGesture, gestureType: pGestureType } = this.props;
        const { useGesture = pUseGesture, gestureType = pGestureType } = this.deviceProps;
        return useGesture && gestureType === 2;
    }
    /**
     * 计算偏移量
     * @param selectedDate - 选择的日期
     * @param immediately - 是否是主动调用
     */
    fixInitScrollOnAdr(selectedDate, immediately = true) {
        const { selectedDate: pSelectedDate, accessibilityPreName } = this.props;
        const dateParam = selectedDate || pSelectedDate;
        const result = computedSelectedSectionIndexes(this.calendarData, dateParam);
        if (result) {
            const offset = computedInitScrollPosition(result, calendarLayout.unscaled, false, 'month');
            // 这里可能会小于0
            const realOffset = offset > 0 ? offset : 0;
            // 将dp转为px
            const pxOffset = PixelRatio.getPixelSizeForLayoutSize(realOffset);
            // 如果需要立即更新，则直接将临时距离赋值给pageOffset
            if (immediately) {
                this.pageOffset = pxOffset;
            }
            this.tempPageOffset = pxOffset;
        }
        else {
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'float_calendar',
                action: 'fix_adr_init_scroll_failed',
                attributes: {
                    operTime: Date.now()
                }
            }));
        }
    }
    /**
     * Native支持时，渲染高版本
     * @param headerData
     * @param contentData
     * @param footerData
     */
    renderHighVersion(headerData, contentData, footerData) {
        const { mode } = this.props;
        const { decelerationRate, fixedIndexes } = this.state;
        const showFooter = mode !== CALENDAR_TYPE.SINGLE;
        const pageViewList = [
            {
                key: 'page0',
                header: ShellComponentHOC,
                headerData: headerData,
                content: ShellComponentHOC,
                contentData: contentData,
                footer: showFooter ? ShellComponentHOC : null,
                footerData: showFooter ? footerData : {}
            }
        ];
        return (<QGestureFloat onRef={(_ref) => {
            this.qGestureFloat = _ref;
        }} 
        // @ts-ignore
        pageViewList={pageViewList} pageNumber={this.state.pageNumber} stopPercent={{
            init: 0.9,
            toInitMin: 0.7,
            toInitMax: 0.9
        }} fixedIndexes={{ page0: fixedIndexes }} borderTopRadius={12} showDuration={300} showDurationDetail={{ low: 10, middle: 10, high: 300 }} hideDuration={300} hideDurationDetail={{ low: 10, middle: 10, high: 300 }} stopDuration={200} forbidSwipeBack={true} recoverSwipeBack={true} forbidFullScreen={true} hideGuideToast={true} decelerationRate={{ page0: decelerationRate }} scrollRate={{ page0: this.state.scrollRate }} initScrollY={{
            page0: !isIOS ? this.pageOffset : 0
        }} onScroll={this.onScroll} onStateChange={this.onStateChange} onTouchMoveChange={this.onTouchMoveChange} onClose={this.onCloseHandler} onCloseAnimateFinish={this.onCloseAnimateFinishHandler} onFixItemTouch={this.onFixItemTouch} onFixItemTouchChange={this.onFixItemTouchChange} onFloatClose={this.onClose}/>);
    }
    /**
     * Native不支持时，渲染低版本
     * @param headerData
     * @param contentData
     * @param footerData
     */
    renderLowVersion(headerData, contentData, footerData) {
        const { title, visible, mode, lowVerCalendarType = 'qSection', swipeBackControl, animationType } = this.props;
        // 如果传递的类型错误，则使用默认值
        const Calendar = importsCalendar[lowVerCalendarType] || importsCalendar.qSection;
        // 使用RN手势浮层
        if (this.useRNGestureFloat) {
            return (<RNGestureFloat title={title} perHeight={90} visible={visible} hasHeader={false} swipeBackControl={swipeBackControl} onShowAnimateFinished={this.onFloatRendered} adaptFooter={false} headerHeight={this.computedStyle.computedLayout.weekHeader.height} injectScrollProps ref={(ref) => {
                this.qGestureFloat = ref;
            }} header={<NaviBar {...headerData}/>} footer={mode !== CALENDAR_TYPE.SINGLE ? (<CalendarBottomModule {...footerData} refreshWidth={this.state.refreshWidth}/>) : null} content={<Calendar {...contentData} refreshWidth={this.state.refreshWidth}/>} onClose={() => this.onClose(false)}/>);
        }
        return (<QPopupLayer title={title} perHeight={90} visible={visible} animationType={animationType || 'slide'} hasHeader={false} swipeBackControl={swipeBackControl} onShow={this.onFloatRendered} onClose={() => this.onClose(false)}>
                <NaviBar {...headerData}/>
                <Calendar {...contentData} refreshWidth={this.state.refreshWidth}/>
                {mode !== CALENDAR_TYPE.SINGLE ? (<CalendarBottomModule {...footerData} refreshWidth={this.state.refreshWidth}/>) : null}
            </QPopupLayer>);
    }
    /**
     * 组装渲染数据
     */
    getRenderData() {
        const { title, hasDirect, tipsContent, onDirectHandler, selectedPayload, otherInfo, buttons, mode, dynamicHeaderView, tipsWrapperCustomStyle, checkedDirect, accessibilityPreName } = this.props;
        const { isTouchMoving, floatDidMount, decelerationRate, userSelectedDate, dataSource } = this.state;
        const headerData = {
            title,
            hasDirect,
            tipsContent,
            dynamicHeaderView,
            onFloatClose: this.closeGestureFloat,
            onDirectHandler,
            tipsWrapperCustomStyle,
            accessibilityPreName,
            checkedDirect,
            weekData: this.weekHeaderData,
            computedStyle: this.computedStyle,
            showWeekHeader: this.useNativeGestureFloat,
            component: NaviBar
        };
        const contentData = Object.assign(Object.assign(Object.assign({}, this.props), this.deviceProps), { dataSource, component: importsCalendar.native, onSelect: this.onSelect, onLayout: this.onCalendarLayout, onSelectScroll: this.onSelectScroll, isTouchMoving, finishCallback: false, floatDidMount, onRenderFinished: this.onRenderFinished, onInitCallback: this.onInitCallback, onDataSourceRendered: this.onDataSourceRendered, decelerationRate, ref: (ref) => {
                this.calendarRef = ref;
            } });
        const footerData = {
            mode,
            selectedPayload,
            otherInfo,
            adaptFooter: this.useNativeGestureFloat || this.useRNGestureFloat,
            userSelectedDate,
            onClickBottomButton: () => this.printStayLog(),
            buttons: commonUtil.isValidArray(buttons)
                ? buttons
                : [{ type: 'default', text: '确定' }],
            component: CalendarBottomModule
        };
        return { headerData, contentData, footerData };
    }
    /**
     * 展示/隐藏日历
     * @param visible
     * @param pageNumber
     */
    update(visible, pageNumber) {
        const { accessibilityPreName } = this.props;
        const nextNumber = visible ? 0 : -1;
        pageNumber !== nextNumber && this.setState({ pageNumber: nextNumber });
        logEvent(new QavEvent({
            page: accessibilityPreName,
            model: 'float_calendar',
            action: visible ? 'show' : 'hide',
            attributes: {
                operTime: Date.now()
            }
        }));
        // 隐藏时置空beginTime
        if (!visible) {
            this.beginTime = 0;
        }
        else if (visible && this.beginTime === 0) {
            // 如果展示时beginTime为零，则设置为当前时间
            this.beginTime = new Date();
        }
        this.hasScrolled = false;
        this.userSelected = false;
    }
    /**
     * 更新完成后比对dataSource，如果更新了则重新Merge节假日
     * @param prevProps
     */
    updateDataSource(prevProps) {
        const { dataSource: prevDataSource } = prevProps;
        const { dataSource, accessibilityPreName } = this.props;
        if (!performanceUtil.fastDeepEqual(prevDataSource, dataSource)) {
            const { userSelectedDate } = this.state;
            const nextDataSource = this.HolidayUtilHandler.mergeHolidayData(dataSource);
            const newUserSelectedDate = updateUserSelectedDate(nextDataSource, userSelectedDate);
            this.setState({
                dataSource: nextDataSource,
                userSelectedDate: newUserSelectedDate
            });
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'float_calendar',
                action: 'update_data_source',
                attributes: {
                    operTime: Date.now()
                }
            }));
        }
    }
    /**
     * 设置滚动状态
     * @param isTouchMoving
     */
    setTouchMovingState(isTouchMoving) {
        const { isTouchMoving: prevStatus } = this.state;
        prevStatus !== isTouchMoving && this.setState({ isTouchMoving });
    }
    /**
     * 重置浮层状态
     * @param closedPageNumber
     * @param pageNumber
     * @param callback
     */
    resetFloatState(closedPageNumber, pageNumber, callback) {
        if (closedPageNumber === 0) {
            this.setState({
                pageNumber,
                floatDidMount: false,
                decelerationRate: this.initDecelerationRate,
                scrollRate: 0.5
            });
        }
        commonUtil.isFunction(callback) && callback();
        // 页面关闭时，将临时滚动距离赋值，并置空
        this.pageOffset = this.tempPageOffset;
    }
    /**
     * 创建一份日历数据结构以便计算初始位置 - adr
     */
    createCalendarData() {
        const { minDate, maxDate, startWeek = 0, blankOut = true, serviceTime } = validAndAdjustProps(this.props);
        this.calendarData = generatorRangeCalendar({
            minDate: minDate,
            maxDate: maxDate,
            start: startWeek,
            blankOut,
            serviceTime
        });
        // 首次调用初始化滚动距离
        this.fixInitScrollOnAdr();
    }
    /**
     * 禁止左滑返回
     * @param enable
     */
    toggleSwipeControl(enable) {
        const { swipeBackControl } = this.props;
        // eslint-disable-next-line no-undef
        swipeBackControl &&
            global.Ext &&
            global.Ext.setSwipeBackEnabled(enable);
    }
    /**
     * 打印提示信息
     * @private
     */
    printNotifyMessage() {
        if (!isIOS) {
            const { useGesture } = this.props;
            if (this.supportQGestureFloat && useGesture) {
                // eslint-disable-next-line no-console
                console.warn(`手势浮层在Android端表现不佳，直接禁止掉；属性：useGesture: ${useGesture} 将被忽略`);
            }
        }
    }
}
FloatCalendar.defaultProps = {
    minDate: new Date(),
    maxDate: dateUtil.appendDate(new Date(), { date: 363 }, { format: true }),
    useGesture: true,
    gestureType: 1,
    mode: 'single',
    swipeBackControl: true,
    stickyHeader: true,
    lowVerCalendarType: 'qSection',
    accessibilityPreName: 'q_design_float_calendar'
};
